import backend, {NOTIFICATION_API} from 'utils/backend/server/api_library';

const sendNotification = (userRn, jobRn, jobTitle, weeklyPay) => {
  const body = {
    type: 'NEW_JOB_POSTING',
    params: {
      jobRn,
      jobTitle,
      weeklyPay,
    },
  };

  const url = `${NOTIFICATION_API}/user/${userRn}/send_notification`;
  return backend.post(url, body);
};

const sendEmail = (userRn, emailData, delayUntil=undefined) => {
  const body = {
    ...emailData,
    source: 'WEBSITE',
    delayUntil,
  };

  const url = `${NOTIFICATION_API}/user/${userRn}/send_email`;
  return backend.post(url, body);
};

const sendSms = (userRn, message, fromEmail, delayUntil=undefined) => {
  const body = {
    message,
    from: fromEmail,
    delayUntil,
  };

  const url = `${NOTIFICATION_API}/user/${userRn}/send_sms`;
  return backend.post(url, body);
};

const getUserEmails = (userRn) => {
  const url = `${NOTIFICATION_API}/user/${userRn}/email`;
  return backend.get(url);
};

const createUserEmail = (userRn, email) => {
  const url = `${NOTIFICATION_API}/user/${userRn}/email`;
  const body = {
    email,
  };
  return backend.post(url, body);
};

const removeUserEmail = (userRn, email) => {
  const url = `${NOTIFICATION_API}/user/${userRn}/email`;
  const body = {
    email,
  };
  return backend.delete(url, body);
};

const createUserSms = (userRn, phoneNumber) => {
  const url = `${NOTIFICATION_API}/user/${userRn}/sms`;
  const body = {
    phoneNumber,
  };
  return backend.post(url, body);
};

const removeUserSms = (userRn, phoneNumber) => {
  const url = `${NOTIFICATION_API}/user/${userRn}/sms`;
  const body = {
    phoneNumber,
  };
  return backend.delete(url, body);
};

const getChannels = (userRn) => {
  const url = `${NOTIFICATION_API}/user/${userRn}/get_channels`;
  return backend.get(url);
};

export default {
  sendNotification,
  sendEmail,
  sendSms,
  getUserEmails,
  createUserEmail,
  removeUserEmail,
  createUserSms,
  removeUserSms,
  getChannels,
};
